import { Button } from '@webmotors/eleanor-ui';
import type { Variant } from '@webmotors/eleanor-ui/webmotors/button';
import { menuButtonStyles, menuButtonOverlayStyles, styles } from '../../vehicle-card.styles';
import { cardActionsStyles } from './card-actions.styles';
import { ACTION_ICON_BY_ID, MoreIcon } from './icons';
import { ACTION_LABELS, STATUS_IDS } from '../../../../utils';
import { myAdsTestId } from '../../../../utils';
import type { TCardActionsConfig, TCardMenuButtonConfig } from '../../vehicle-card.types';
import type { TActionId } from '../../../../utils';

const getActionVariant = (action: TActionId, status: string): Variant => {
	if (action === 'boost') return 'primary';
	if (action === 'markAsSold') return 'tertiary-situational';
	if (status === STATUS_IDS.INACTIVE && action === 'reactivate') return 'secondary';
	if (status === STATUS_IDS.INCOMPLETE && action === 'complete') return 'secondary';
	if (status === STATUS_IDS.PAYMENT_PENDING && action === 'pay') return 'secondary';
	if (status === STATUS_IDS.PAYMENT_UNAUTHORIZED && action === 'pay') return 'primary';
	if (status === STATUS_IDS.TRANSACTION_FAILED && action === 'pay') return 'primary';
	if (status === STATUS_IDS.UNAVAILABLE && action === 'contactSupport') return 'secondary';
	return 'tertiary-situational';
};

const CardActions = ({ adId, actions, status, onAction }: TCardActionsConfig) => {
	if (actions.length === 0) return null;

	return (
		<div className={styles.actionsRow}>
			{actions.map((action) => {
				const variant = getActionVariant(action, status);
				const icon = ACTION_ICON_BY_ID[action];

				return (
					<Button
						key={action}
						variant={variant}
						size="small"
						className={action === 'boost' ? cardActionsStyles.boostButton : undefined}
						leftIcon={icon ? { component: icon } : undefined}
						onClick={() => onAction(action)}
						data-testid={myAdsTestId.cardAction(action, adId)}
					>
						{ACTION_LABELS[action]}
					</Button>
				);
			})}
		</div>
	);
};

CardActions.displayName = 'CardActions';

const CardMenuButton = ({ onClick, overlay = false }: TCardMenuButtonConfig) => (
	<button
		type="button"
		className={overlay ? menuButtonOverlayStyles : menuButtonStyles}
		onClick={onClick}
		aria-label="Menu de ações"
	>
		<MoreIcon />
	</button>
);

CardMenuButton.displayName = 'CardMenuButton';

export { CardActions, CardMenuButton };
